import { DateTime } from "luxon";

export function TimeHourMinute({ date }: { date: DateTime }) {
  return <>{date.toFormat("HH:mm")}</>;
}
